import * as React from 'react';
import {connect} from 'react-redux';
import {RootState} from '../../../../store';
import * as CommentsStore from '../../../../store/comments';
import * as ProjectsStore from '../../../../store/projects';
import * as CommonValuesStore from '../../../../store/common-values';
import {bindActionCreators} from 'redux';
import AuditDetails from './AuditDetails';
import {UserState} from 'redux-oidc';
import {match} from 'react-router';
import Loading from '../../../application/Loading';
import {ConnectedRouterProps} from 'connected-react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {Button} from '@mui/material';
import {ProjectStatus} from '../../../../store/projects/commonTypes';
import Comments from '../../../comments/Comments';
import GoBackContainer from "../../../application/GoBackContainer";
import AuditIssues from "./AuditIssues";
import * as RuntimeStore from "../../../../store/runtime";

// At runtime, Redux will merge together...
type AuditViewFormProps =
    ProjectsStore.ProjectsState
    & typeof ProjectsStore.actionCreators
    & { comments: CommentsStore.CommentsState }
    & typeof CommentsStore.actionCreators
    & CommonValuesStore.CommmonValuesState
    & typeof CommonValuesStore.actionCreators
    & typeof RuntimeStore.actionCreators
    & UserState
    & ConnectedRouterProps
    & { match: match<{ id: string }> };

class AuditViewFormContainer extends React.PureComponent<AuditViewFormProps> {
    auditId: string = '';

    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.auditId = this.props.match.params.id;
        this.props.requestAudit(this.auditId);
        this.props.requestAuditComments(this.auditId);
        this.props.requestIssuesForReview(this.auditId);
        this.props.requestScoringReport(this.auditId);
    }

    public render() {
        return (
            <React.Fragment>
                <GoBackContainer title={'Revisjonsdetaljer'} onGoBack={() => this.props.history.goBack()}>
                    {this.props.isLoading ? (
                        <Loading/>
                    ) : (this.props.audit ? (
                        <div>
                            <AuditDetails audit={this.props.audit} user={this.props.user!}
                                          showError={error => this.props.showNotification(error, "error")}/>
                            {(this.props.audit.statusId == 283210000 || this.props.audit.statusId == 283210001) && (
                                <AuditIssues scoringReport={this.props.scoringReport} issues={this.props.issues}
                                             isLoading={this.props.isIssuesLoading || this.props.isScoringReportLoading}/>
                            )}
                        </div>
                    ) : (
                        <span></span>
                    ))}
                </GoBackContainer>
            </React.Fragment>
        );
    }
}

export default connect(
    (state: RootState) => {
        const {projects, commonValues, oidc, comments, runtime} = state;
        return {
            ...projects,
            ...commonValues,
            ...oidc,
            ...runtime,
            comments: {...comments}
        };
    },
    (dispatch) => {
        return {
            ...bindActionCreators(
                Object.assign(
                    {},
                    ProjectsStore.actionCreators,
                    CommentsStore.actionCreators,
                    CommonValuesStore.actionCreators
                ), dispatch)
        };
    }
)(AuditViewFormContainer as any); // eslint-disable-line @typescript-eslint/no-explicit-any
